const texts = {
  before: 'anterior',
  after: 'siguiente'
}

export default texts
